"use strict";
import {on, find, removeClass, addClass, findIn, findAll, findAllIn, closest, removeAttribute, setAttribute} from "@elements/dom-utils";
import axios from "axios";
import {visualizeCompleteness, setTabData, updateTab, unCompleteTab, completeTab} from "../tabManager";
import TerracePlanner from "../index";
import Panzoom from '@panzoom/panzoom'
import {enableLoadingOverlay} from "../applicationLoading";
import * as terracePlannerPlankPatternButtonBars from "./plankPatternButtonBars";
import {translate} from '@elements/translations';

let imageNode, priceNode, lengthsNode, wasteNode;
let availabilityData = false;

export function init() {
    imageNode = findIn('.js-planner__pattern-svg', TerracePlanner.element); //svg element
    priceNode = findIn('.js-planner__pattern-price', TerracePlanner.element); // price placeholder
    lengthsNode = findIn('.js-planner__pattern-values', TerracePlanner.element);
    wasteNode = findIn('.js-planner__pattern-waste', TerracePlanner.element);

    if (findAllIn('.js-planner__pattern-select-input', TerracePlanner.element)) {
        findAllIn('.js-planner__pattern-select-input', TerracePlanner.element).map((radioButton) => {
            on('click', (evt) => switchPatternListener(evt, radioButton), radioButton);
        });
    }

    on('click', () => {
        plankPatternCompleteListener();
    }, findIn('.js-planner__pattern-save', TerracePlanner.element));

    on('click', () => {
        restrictLengthsListener();
    }, findIn('.js-planner__pattern-restrict-lengths', TerracePlanner.element))

    if(TerracePlanner.tabConfig.plankPattern.complete) {
        updatePlankPattern();
        visualizeCompleteness('plankPattern');
    }

    initPlankPartSizeHover();
    availabilityData = null;
    fetchAvailability();


    let zoomContainer = findIn('.js-panzoom', TerracePlanner.element),
        svg = findIn('.js-panzoom__svg', zoomContainer),
        reset = findIn('.js-panzoom__zoom-reset', zoomContainer),
        zoomIn = findIn('.js-panzoom__zoom-in', zoomContainer),
        zoomOut = findIn('.js-panzoom__zoom-out', zoomContainer);

    const panzoom = Panzoom(svg, {
        startScale: 0.9
    });

    on('click', (evt) => panzoom.zoomIn(), zoomIn);
    on('click', (evt) => panzoom.zoomOut(), zoomOut);
    on('click', (evt) => panzoom.reset(), reset);


    //init buttons
    terracePlannerPlankPatternButtonBars.init();
}

function initPlankPartSizeHover() {
    let tooltip = findIn('.js-planner__pattern-tooltip', TerracePlanner.element);

    let plankParts = findAllIn('.plankPart', imageNode),
        plankContainer = findIn('svg', imageNode);
    plankParts.map((plankPart) => {
        on('mouseover', (evt) => {
            tooltip.innerHTML = plankPart.getAttribute('data-dimensions');
            removeAttribute('hidden', tooltip);
        }, plankPart);

        on('mouseleave', (evt) => {
            setAttribute('hidden', true, tooltip);
        }, plankPart);

        on('mousemove', (evt) => {
            tooltip.style.left = evt.clientX + 20 + 'px';
            tooltip.style.top = evt.clientY + 'px';
        }, plankContainer);
    });
}

/**
 * moves the selected pattern item's data to the center
 *
 * @param event
 */
function switchPatternListener(evt, radio) {
    let button = closest('.js-planner__pattern-select', radio);
    let itemImage = findIn('.js-planner__pattern-select-image', button);
    let itemPrice = findIn('.js-planner__pattern-select-price', button);
    let itemLengths = findIn('.js-planner__pattern-select-lengths', button);
    let itemWaste = findIn('.js-planner__pattern-select-waste', button);

    findAllIn('.js-planner__pattern-select', TerracePlanner.element).map((item) => {
        removeClass('is-selected', item);
    });

    addClass('is-selected', button);

    imageNode.innerHTML = itemImage.innerHTML;
    priceNode.innerHTML = itemPrice.innerHTML;
    lengthsNode.innerHTML = itemLengths.innerHTML;
    wasteNode.innerHTML = itemWaste.innerHTML;

    findAllIn('.js-planner__pattern-restricted-label', TerracePlanner.element).map((label) => {
        removeClass('font-bold', label);
    });

    findAllIn('.js-planner__pattern-loader', TerracePlanner.element).map((loader) => {
        setAttribute('hidden', true, loader);
    });

    Object.keys(JSON.parse(button.getAttribute('data-used-products'))).map(function(productId){
        if (findIn('.js-planner__pattern-restricted-label', find('.js-planner__pattern-restricted-length[data-product-id="' + productId + '"]'))) {
            addClass('font-bold', findIn('.js-planner__pattern-restricted-label', find('.js-planner__pattern-restricted-length[data-product-id="' + productId + '"]')));
        }
        if (find('.js-planner__pattern-restricted-length[data-product-id="' + productId + '"] .js-planner__pattern-loader')) {
            removeAttribute('hidden', find('.js-planner__pattern-restricted-length[data-product-id="' + productId + '"] .js-planner__pattern-loader'));
        }
        showNeededLengthDetails();
    });

    initPlankPartSizeHover();
}

/**
 * collects data from the tab panel, updates and completes the tab
 *
 */
export function updatePlankPattern() {
    let activePattern = findIn('.js-planner__pattern-select.is-selected', TerracePlanner.element);
    let activePatternIndex = activePattern.getAttribute('data-index');
    let text = translate('terracePlanner.plankPattern.patternIndex') + ' ' + (Number(activePatternIndex) + 1);

    setTabData('plankPattern', {
        index: activePatternIndex
    });

    updateTab('plankPattern', text);
    unCompleteTab('summary');
}

/**
 * Listener to determine the currently selected pattern's index and complete the tab
 *
 * @param event
 */
function plankPatternCompleteListener() {
    updatePlankPattern();
    completeTab('plankPattern', 'summary');
}

/**
 * used to restrict available plank lengths by checkboxs
 *
 * @param event
 */
function restrictLengthsListener() {
    let data = new FormData();
    data.append('index', 0)
    Object.entries(findAll('.js-planner__pattern-restricted-length-input:checked')).forEach(([index, item]) => {
        data.append('restrictedLength[]', item.value)
    });

    setTabData('plankPattern', data);

    unCompleteTab('summary');
    TerracePlanner.tabConfig['plankPattern'].initialized = false;
    enableLoadingOverlay();
    completeTab('plankPattern', 'plankPattern');
}

function fetchAvailability() {
    let data = new FormData();
    findAll('.js-planner__pattern-select').map((item, index) => {
        Object.entries(JSON.parse(item.getAttribute('data-used-products'))).forEach(([key, value]) => {
            data.append('productAmounts['+ index +']['+ key +']', value)
        });
    });

    axios({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        url: '/r/terraceplanner/availability/check-availability',
        responseType: 'json',
        data: data
    }).then(({data}) => {
        availabilityData = data;
        showNeededLengthDetails();
    });
}

function showNeededLengthDetails() {
    let activePattern = find('.js-planner__pattern-select.is-selected');

    findAllIn('.js-planner__pattern-availabilty', TerracePlanner.element).map((item) => {
        setAttribute('hidden', true, item);
    });

    findAllIn('.js-planner__pattern-restricted-length-amount', TerracePlanner.element).map((item) => {
        setAttribute('hidden', true, item);
    });

    Object.keys(JSON.parse(activePattern.getAttribute('data-used-products'))).map(function(productId, index){
        let activeItemCheckbox = find('.js-planner__pattern-restricted-length[data-product-id="' + productId + '"]')
        if(availabilityData) { // check if availability data is already loaded
            let productAvailability = availabilityData[activePattern.getAttribute('data-index')][productId];

            if (findIn('.js-planner__pattern-loader', activeItemCheckbox)) {
                findIn('.js-planner__pattern-loader', activeItemCheckbox).replaceWith(document.createRange().createContextualFragment('<span class="js-terracePlanner__restricted-length-availability state-circle" hidden></span>'));
            }

            let availabilityItem = findIn('.js-terracePlanner__restricted-length-availability', activeItemCheckbox);

            removeAttribute('hidden', availabilityItem);
            addClass('state-circle--' + productAvailability.availabilityClass, availabilityItem);
            setAttribute('title', productAvailability.message, availabilityItem);
        }

        findIn('.js-planner__pattern-restricted-length-value', activeItemCheckbox).innerHTML = JSON.parse(activePattern.getAttribute('data-used-products'))[productId];
        removeAttribute('hidden', findIn('.js-planner__pattern-restricted-length-amount', activeItemCheckbox));
    });
}